
const Privacy = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/9c863003ff2a45a7fdb4b616e355a476/83a4210232d56303cd212f2c5e8ac070.png" 
                alt="ProArk Haven Logo" 
                className="h-12 w-auto"
              />
            </a>
            <a 
              href="/"
              className="bg-orange-600 text-white px-6 py-2 rounded-full hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Back to Home
            </a>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-8">
            <strong>Last Updated:</strong> December 2024
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Information We Collect</h2>
            <p className="text-gray-700 mb-4">
              At ProArk Haven Adult Day Care and Recreation Center, we collect information that you provide directly to us, such as when you:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Contact us for information about our services</li>
              <li>Schedule a tour or consultation</li>
              <li>Enroll in our adult day care programs</li>
              <li>Complete forms or applications</li>
              <li>Communicate with our staff</li>
            </ul>
            <p className="text-gray-700">
              This may include personal information such as names, addresses, phone numbers, email addresses, emergency contacts, medical information, and other relevant details necessary for providing our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. How We Use Your Information</h2>
            <p className="text-gray-700 mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Provide and maintain our adult day care services</li>
              <li>Communicate with participants and their families</li>
              <li>Ensure the safety and well-being of our participants</li>
              <li>Coordinate care with healthcare providers when authorized</li>
              <li>Process payments and manage accounts</li>
              <li>Improve our services and programs</li>
              <li>Comply with legal and regulatory requirements</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Information Sharing and Disclosure</h2>
            <p className="text-gray-700 mb-4">
              We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except in the following circumstances:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>With healthcare providers when necessary for participant care and with proper authorization</li>
              <li>With emergency contacts in case of medical emergencies</li>
              <li>When required by law or to comply with legal processes</li>
              <li>To protect the rights, property, or safety of ProArk Haven, our participants, or others</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Data Security</h2>
            <p className="text-gray-700">
              We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. This includes physical, electronic, and administrative safeguards. However, no method of transmission over the internet or electronic storage is 100% secure.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Your Rights</h2>
            <p className="text-gray-700 mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Access and review your personal information</li>
              <li>Request corrections to inaccurate information</li>
              <li>Request deletion of your information (subject to legal requirements)</li>
              <li>Withdraw consent for certain uses of your information</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Contact Information</h2>
            <p className="text-gray-700 mb-4">
              If you have questions about this Privacy Policy or wish to exercise your rights, please contact us:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700 mb-2"><strong>ProArk Haven Adult Day Care and Recreation Center</strong></p>
              <p className="text-gray-700 mb-2">222 McIntyre Street West, #510B</p>
              <p className="text-gray-700 mb-2">North Bay, Ontario P1B 2Y8</p>
              <p className="text-gray-700 mb-2">Phone: 705.667.1780</p>
              <p className="text-gray-700">Email: admin@proarkhaven.ca</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Changes to This Policy</h2>
            <p className="text-gray-700">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. We encourage you to review this Privacy Policy periodically.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              © 2024 ProArk Haven Adult Day Care and Recreation Center. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Privacy;
